module.exports = __webpack_public_path__ + "static/media/koinvestor_main.f6ab4f84.png";